import { ref } from 'vue'

export default defineNuxtPlugin((nuxtApp) => {
    const { $i18n } = nuxtApp
    
    // Shared state for dialog queue (supports multiple dialogs)
    const dialogQueue = ref([])
    
    // Provide the queue to the app so a component can render it
    nuxtApp.provide('dialogQueue', dialogQueue)
    
    const showDialog = (props) => {
        return new Promise((resolve) => {
            const dialog = {
                id: Date.now() + Math.random(),
                props,
                resolve: (value) => {
                    const index = dialogQueue.value.findIndex(d => d.id === dialog.id)
                    if (index > -1) {
                        dialogQueue.value.splice(index, 1)
                    }
                    resolve(value)
                }
            }
            dialogQueue.value.push(dialog)
        })
    }
    
    const alert = (text, options = {}) => {
        return showDialog({
            trueText: $i18n.t('app.ok'),
            falseText: '',
            color: 'primary',
            icon: 'mdi-information',
            width: options.width ?? 350,
            title: $i18n.t('app.alertTitle'),
            message: text
        })
    }

    const confirm = (text, options = {}) => {
        return showDialog({
            trueText: $i18n.t('app.yes'),
            falseText: $i18n.t('app.no'),
            color: 'primary',
            icon: 'mdi-help-circle',
            width: options.width ?? 350,
            title: $i18n.t('app.confirmTitle'),
            message: text
        })
    }

    return {
        provide: {
            alert,
            confirm
        }
    }
})
